export default __webpack_public_path__ + "static/23-89686208c9d51654e0adaf755663301d.png";